/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';

import { LogoSvg } from '../../assets/Logo';

import messages from './messages';
import { logoContainer } from './styles';

export const AtlassianIntelligenceLogo = ({ isDisabled = false }: { isDisabled?: boolean }) => {
	const { formatMessage } = useIntl();
	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
		<div data-testid="atlassian-intelligence-logo" css={logoContainer}>
			<LogoSvg alt={formatMessage(messages.logoAltText)} isDisabled={isDisabled} />
		</div>
	);
};
